import { InputProps } from 'components/UI/Input/Input'

const fields = [
  { id: 'name', label: 'Name', placeholder: 'Module Name' },
] as InputProps[]

export default fields
